import React from "react";
import "../style/component/WebinarsTable.css";
import { useTranslation } from "../contexts/TranslationContext";

function WebinarsTable({ items, headerTexts }) {
  const { currentLanguage } = useTranslation();
  const linkText = currentLanguage === "en" ? "View" : "Xem";

  return (
    <section className="webinars-table-wrapper">
      <table className="webinars-table rounded">
        <thead>
          <tr>
            {headerTexts.map((header, index) => (
              <th key={index} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.topic}</td>
              <td>{item.speaker}</td>
              <td>{item.curator}</td>
              <td>{item.abstract}</td>
              <td>{item.recordingDate}</td>
              <td>{item.publicationDate}</td>
              <td>
                {item.link && (
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {linkText}
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

export default WebinarsTable;
